import React, { useEffect, useState } from "react";
import axios from "axios";

const toAddress =
  "kaspa:qzk0z20m7sm7rm35yvzpuv8a5pzlzgur5yn90f65lm4err50ujn9s8pr6ltpz";

function Leaderboard() {
  const [donors, setDonors] = useState([]);

  useEffect(() => {
    const fetchDonors = async () => {
      try {
        const response = await axios.get(
          `https://api.kaspa.org/addresses/${encodeURIComponent(
            toAddress
          )}/full-transactions`
        );

        const transactions = response.data || [];
        const donorData = {};

        transactions.forEach((transaction) => {
          const outputs = transaction.outputs || [];

          const donationOutput = outputs.find(
            (output) => output.script_public_key_address === toAddress
          );

          const donorOutput = outputs.find(
            (output) => output.script_public_key_address !== toAddress
          );

          if (donationOutput && donorOutput) {
            const donorAddress = donorOutput.script_public_key_address;
            const amountKAS = donationOutput.amount / 1e8;

            if (donorData[donorAddress]) {
              donorData[donorAddress] += amountKAS;
            } else {
              donorData[donorAddress] = amountKAS;
            }
          }
        });

        const sortedDonors = Object.entries(donorData)
          .map(([address, totalAmount]) => ({
            name: address,
            score: totalAmount,
          }))
          .sort((a, b) => b.score - a.score);

        setDonors(sortedDonors.slice(0, 11));
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des transactions :",
          error
        );
      }
    };

    fetchDonors();
  }, []);

  const formatAddress = (address) => {
    return `${address.slice(0, 6)}...${address.slice(-6)}`;
  };

  return (
    <div className="leaderboard">
      <h2 className="leaderboard_title">Top KAS Donors</h2>
      <div className="leaderboard_grid">
        {donors.map((donor, index) => (
          <div
            className={`leaderboard_item ${index < 3 ? "top_donor" : ""}`}
            key={index}
          >
            <div className="leaderboard_rank">
              {index === 0
                ? "🥇"
                : index === 1
                ? "🥈"
                : index === 2
                ? "🥉"
                : index + 1}
            </div>
            <div className="leaderboard_name">
              <a
                href={`https://kas.fyi/address/${donor.name}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 underline"
              >
                {formatAddress(donor.name)}
              </a>
            </div>
            <div className="leaderboard_score">
              {donor.score.toLocaleString()} KAS
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Leaderboard;
